import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=13572d8a&scoped=true&"
import script from "./Industry.vue?vue&type=script&lang=js&"
export * from "./Industry.vue?vue&type=script&lang=js&"
import style0 from "./Industry.vue?vue&type=style&index=0&id=13572d8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13572d8a",
  null
  
)

export default component.exports